import { store } from "stores/Store";
import styles from './Details.module.scss';
import React from "react";
import { Tab } from "Modules/PractitionerBaseballCard";
import Text from "components/Text/Text";
import { observer } from "mobx-react";


// Helper: translate raw data_source → friendly text
const getDataSourceLabel = (ds?: string): string => {
  switch (ds) {
    case "PRACTITIONER_ACCOUNT_VIEW":
      return "From Netsuite";
    case "PRACTITIONER_ACCOUNT_VIEW_NM":
      return "From Badger Export";
    case "PRACTITIONER_DISTRIBUTOR_ACCOUNT_VIEW":
      return "Distributor";
    default:
      return ds || "Unknown"; // fallback if undefined or unrecognized
  }
};

const getChannelLabel = (ds?: string): string => {
  switch (ds) {    
    case "PRACTITIONER_ACCOUNT_VIEW_NM":
      return "Not in Netsuite";    
    default:
      return ds || ""; // fallback if undefined or unrecognized
  }
};


const handleContact = (opt: string) => {
  switch (opt) {
    case 'email':
      window.open(`mailto:${store.currentPractitioner?.email}`, '_blank');
      break;
    case 'phone':
      window.open(`tel:${store.currentPractitioner?.phone}`, '_blank');
      break;

  }
}
interface IPractitionerDetails {
  navigate: (tab: Tab) => void;
}

const PractitionerDetails = observer(({navigate}: IPractitionerDetails) => {
  const [distance, setDistance] = React.useState<number | null>(null);

  React.useEffect(() => {
    calculteDistance()?.then((distance: number | null) => {
      if (distance !== null) {
        setDistance(distance);
      }
    })
  }, []);

  console.log("store.currentPractitioner=", store.currentPractitioner);

  const calculteDistance = () => {
    if (!store.currentPractitioner?.latitude || !store.currentPractitioner?.longitude) {
      return null;
    }
  
    // Get current position from browser
    if ("geolocation" in navigator) {
      return new Promise<number>((resolve, reject) => {
        navigator.geolocation.getCurrentPosition((position) => {
          const lat1 = position.coords.latitude;
          const lon1 = position.coords.longitude;
          const lat2 = store.currentPractitioner.latitude;
          const lon2 = store.currentPractitioner.longitude;
  
          // Calculate distance using Haversine formula
          const R = 6371; // Radius of earth in km
          const dLat = (lat2 - lat1) * Math.PI / 180;
          const dLon = (lon2 - lon1) * Math.PI / 180;
          const a = 
            Math.sin(dLat/2) * Math.sin(dLat/2) +
            Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * 
            Math.sin(dLon/2) * Math.sin(dLon/2);
          const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
          const distance = R * c;
  
          resolve(Math.round(distance * 0.621371)); // Convert to miles and round
        }, (error) => {
          reject(error);
        });
      });
    }
    
    return null;
  }

  // Grab lat/lon once, so we don’t repeat the optional chaining each time:
  const lat = store.currentPractitioner?.latitude;
  const lon = store.currentPractitioner?.longitude;

  return (
    <div className={styles.wrapper}>
      {/*<div className={styles.sectionWrapper}>
        <p className={styles.headerText}>CONTACT INFORMATION</p>
      </div>*/}
      <div className={styles.twoColumnWrapper}>
        <div>
          <Text type="primary" bold>Data Source</Text>
          {/*<Text>{getDataSourceLabel(store.currentPractitioner?.data_source)}</Text>*/}
          <Text>
            {(
              store.currentPractitioner?.status === "LEAD-INCOMPLETE" ||
              store.currentPractitioner?.status === "LEAD-READY2SUBMIT"
            )
              ? "Lead created with Sales Assistant"
              : getDataSourceLabel(store.currentPractitioner?.data_source)
            }
          </Text>          
        </div>
        <div>
          <Text type="primary" bold> </Text>          
          <Text>{getChannelLabel(store.currentPractitioner?.name_dfh_channel)}</Text>          
        </div>        
      </div>

      <div className={styles.sectionWrapper}>
        <p className={styles.headerText}>BUSINESS DETAILS</p>
      </div>
      <div className={styles.twoColumnWrapper}>
        <div>
          <Text type="primary" bold>Phone</Text>
          {/*<Text>{store.currentPractitioner?.phone}</Text>*/}
          {store.currentPractitioner?.phone ? (
            <Text onClick={() => handleContact('phone')}>{store.currentPractitioner?.phone}</Text>
          ) : (            
            <div className={styles.missingValue}>Missing</div>
          )}
        </div>
        <div>
          <Text type="primary" bold>Email</Text>
          {/*<Text>{store.currentPractitioner?.email}</Text>*/}
          {store.currentPractitioner?.email ? (
            <Text onClick={() => handleContact('email')}>{store.currentPractitioner?.email}</Text>
          ) : (            
            <div className={styles.missingValue}>Missing</div>
          )}
        </div>
        <div>
          <Text type="primary" bold>Account Owner</Text>
          <Text>{store.currentPractitioner?.fmc}</Text>
        </div>
        <div>
          <Text type="primary" bold>Status</Text>          
          {store.currentPractitioner?.status ? (
            <Text>{store.currentPractitioner?.status}</Text>
          ) : (            
            <div className={styles.missingValue}>Missing</div>
          )}
        </div>
        <div>
          <Text type="primary" bold>Specialty</Text>          
          {store.currentPractitioner?.specialty ? (
            <Text>{store.currentPractitioner?.specialty}</Text>
          ) : (            
            <div className={styles.missingValue}>Missing</div>
          )}
        </div>        
        <div>
          <Text type="primary" bold>Netsuite ID</Text>
          {store.currentPractitioner?.netsuite_id ? (
            <Text>{store.currentPractitioner.netsuite_id}</Text>
          ) : (            
            <div className={styles.missingValue}>Missing</div>
          )}
        </div>
      </div>

      <div className={styles.sectionWrapper}>
        <p className={styles.headerText}>LOCATION</p>
      </div>
      <div className={styles.twoColumnWrapper}>
        <div>
          <Text type="primary" bold>Address</Text>          
          {store.currentPractitioner?.address ? (
            <Text>{store.currentPractitioner.address}</Text>
          ) : (            
            <div className={styles.missingValue}>MISSING</div>
          )}
        </div>
        <div>
          <Text type="primary" bold>City & State</Text>
          {(store.currentPractitioner?.city && store.currentPractitioner?.state) ? (
            <Text>{`${store.currentPractitioner?.city}, ${store.currentPractitioner?.state}`}</Text>
          ) : (            
            <div className={styles.missingValue}>MISSING</div>
          )}
          {/*<Text>{`${store.currentPractitioner?.city}, ${store.currentPractitioner?.state}`}</Text>*/}
        </div>
        <div>
          <Text type="primary" bold>Distance</Text>
          {/*<Text>{distance ? `${distance} miles away` : 'Calculating...'}</Text>*/}
          {lat == null || lon == null
              ? (<Text>Cannot Calculate: Missing Lat/Long.</Text>)
              : distance == null
              ? (<Text>Cannot calculate: did you allow app to use GPS?</Text>)
              : (<Text>{`${distance} miles away`}</Text>)}
        </div>
        <div>
          <Text type="primary" bold>Lat & Long</Text>
          {(lat && lon) ? (
            <Text>{`${lat}, ${lon}`}</Text>
          ) : (            
            <div className={styles.missingValue}>MISSING</div>
          )}
          {/*<Text>{`${store.currentPractitioner?.latitude}, ${store.currentPractitioner?.longitude}`}</Text>*/}
        </div>      
      </div>
    </div>
  )
})

export default PractitionerDetails;